import { render, staticRenderFns } from "./bigNumber.vue?vue&type=template&id=612b8c14&scoped=true&"
import script from "./bigNumber.vue?vue&type=script&lang=js&"
export * from "./bigNumber.vue?vue&type=script&lang=js&"
import style0 from "./bigNumber.vue?vue&type=style&index=0&id=612b8c14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b8c14",
  null
  
)

export default component.exports